import SFetch from '@app/utils/sfetch'
import {
  ExistingCompanyLinkResponse,
  AvailableCompanyResponse,
  ExistingCompanyLink,
} from '../types'

export const createCompanyLink = async ({
  sourceCompanyId,
  userId,
}: {
  sourceCompanyId: number
  userId: number
}): Promise<ExistingCompanyLink | null> => {
  const url = window.Silverfin.Routes.company_links_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId
  )

  return await SFetch.json(url, {
    method: 'POST',
    body: {
      company_link: {
        source_company_id: sourceCompanyId,
        user_id: userId,
      },
    },
  })
}

export const deleteCompanyLink = async ({
  sourceCompanyId,
}: {
  sourceCompanyId: number
}): Promise<null> => {
  const url = window.Silverfin.Routes.company_link_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    sourceCompanyId
  )

  return await SFetch.json(url, {
    method: 'DELETE',
  })
}

export const getExistingCompanyLinks =
  async (): Promise<ExistingCompanyLinkResponse | null> => {
    const url = window.Silverfin.Routes.existing_links_company_links_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId
    )

    return await SFetch.json<ExistingCompanyLinkResponse>(url)
  }

export const getAvailableCompanies =
  async (): Promise<AvailableCompanyResponse | null> => {
    const url = window.Silverfin.Routes.available_companies_company_links_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId
    )

    return await SFetch.json<AvailableCompanyResponse>(url)
  }
